module.exports = __webpack_public_path__ + "img/idcard.ec9b429b.png";